import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

const UUID_REGEX = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/
const VERSAO_REGEX = /^\d+\.\d+\.\d+$/

const somenteDigitos = (val: string) => val.replace(/\D/g, '')

// Todos os campos são opcionais (a completude é exigida pelo gate de ativação no
// backend), mas quando preenchidos precisam ter formato válido.
export const esusConfigSchema = (t?: TFunction) => {
  return Yup.object().shape({
    urlPec: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .max(255, 'URL deve ter no máximo 255 caracteres')
      .test(
        'urlPecFormat',
        'Informe uma URL válida iniciando com http:// ou https://',
        (val) => !val || /^https?:\/\/\S+$/.test(val)
      ),
    usuario: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .max(100, 'Usuário deve ter no máximo 100 caracteres'),
    senha: Yup.string().nullable().notRequired(),
    contraChave: Yup.string().nullable().notRequired(),
    uuidInstalacao: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        'uuidFormat',
        'UUID inválido (formato esperado: xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx)',
        (val) => !val || UUID_REGEX.test(val)
      ),
    cpfOuCnpj: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test('cpfOuCnpjFormat', 'Informe um CPF (11 dígitos) ou CNPJ (14 dígitos) válido', (val) => {
        if (!val) return true
        const digitos = somenteDigitos(val)
        return digitos.length === 11 || digitos.length === 14
      }),
    nomeOuRazaoSocial: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .max(200, 'Nome ou razão social deve ter no máximo 200 caracteres'),
    versaoLedi: Yup.string()
      .trim()
      .nullable()
      .notRequired()
      .test(
        'versaoLediFormat',
        'Versão inválida (formato esperado: X.Y.Z, ex: 8.5.0)',
        (val) => !val || VERSAO_REGEX.test(val)
      ),
  })
}
